import { useSessionStore } from '@/stores/session';

export default defineNuxtPlugin(async (nuxtApp) => {
  const config = useRuntimeConfig();
  const sessionStore = useSessionStore();

  if (!sessionStore.token) {
    await sessionStore.fetchToken();
  }

  const api = $fetch.create({
    baseURL: config.public.apiBaseUrl + 'api/',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${sessionStore.token}`
    },
    async onResponseError(context, { response }) {
      if (response.status === 401) {
        sessionStore.fetchToken();

        context.request.headers.set('Authorization', `Bearer ${sessionStore.token}`);
        return context.retry();
        // await nuxtApp.runWithContext(() => navigateTo('/login'))
      }
    }
  })

  // Expose to useNuxtApp().$api
  return {
    provide: {
      api
    }
  }
})
